export enum ModuleAccessLevel {
    None = 0,
    Local = 1,
    Central = 2,
    Global = 3,
}
